import RoutesApp from "./routes/RoutesApp";

function App() {
  return (
    <>
      <RoutesApp />
    </>
  );
}

export default App;
